import { createFileRoute } from '@tanstack/react-router'
import { HabitManager } from '@/features/habits/HabitManager'
import { PageHeading } from '@/components/PageHeading'

export const Route = createFileRoute('/habits')({
  component: HabitsPage,
})

function HabitsPage() {
  return (
    <div className="py-6 sm:py-8">
      <PageHeading title="Habits" />
      <div className="mt-6">
        <HabitManager />
      </div>
    </div>
  )
}
